import { loadStripe, type Stripe } from '@stripe/stripe-js';

/**
 * Stripe.js loader singleton. `loadStripe` returns a promise that
 * resolves the Stripe object once stripe.js has loaded; calling it
 * more than once returns the same promise, so we memoise at module
 * scope and hand the same promise to every `<Elements>` provider.
 *
 * The publishable key is build-time config injected via
 * `VITE_STRIPE_PUBLISHABLE_KEY` (a Terraform output baked into the
 * SPA bundle, same flow as VITE_API_URL). Publishable keys are
 * designed to ship in the browser — unlike the secret key, there's
 * nothing sensitive here.
 */
let cached: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (cached !== null) return cached;
  const key: unknown = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
  if (typeof key !== 'string' || key.length === 0) {
    throw new Error(
      'Missing required env var: VITE_STRIPE_PUBLISHABLE_KEY. ' +
        'Copy apps/web/.env.example to apps/web/.env.local and fill in the value.',
    );
  }
  cached = loadStripe(key);
  return cached;
}
